import { useId } from "react";
import type { ReactNode } from "react";

/** `<select>` com o rótulo no padrão de campo do portal. */
export function CampoDeEscolha({
  rotulo,
  valor,
  aoMudar,
  opcoes,
  vazio,
  className,
}: {
  rotulo: string;
  valor: string;
  aoMudar: (valor: string) => void;
  opcoes: ReadonlyArray<{ valor: string; rotulo: string }>;
  /** Rótulo da opção de valor vazio; ausente = sem opção vazia. */
  vazio?: string;
  className?: string;
}) {
  const id = useId();
  return (
    <div className={`campo ${className ?? ""}`}>
      <label className="campo__rotulo" htmlFor={id}>
        {rotulo}
      </label>
      <select id={id} className="campo__controle" value={valor} onChange={(e) => aoMudar(e.target.value)}>
        {vazio !== undefined ? <option value="">{vazio}</option> : null}
        {opcoes.map((opcao) => (
          <option key={opcao.valor} value={opcao.valor}>
            {opcao.rotulo}
          </option>
        ))}
      </select>
    </div>
  );
}

/** Caixa de marcação com rótulo clicável. */
export function CaixaDeMarcar({
  rotulo,
  marcada,
  aoMudar,
  ajuda,
}: {
  rotulo: string;
  marcada: boolean;
  aoMudar: (marcada: boolean) => void;
  ajuda?: ReactNode;
}) {
  const id = useId();
  return (
    <div className="campo">
      <label htmlFor={id} className="flex items-center gap-2">
        <input id={id} type="checkbox" checked={marcada} onChange={(e) => aoMudar(e.target.checked)} />
        <span>{rotulo}</span>
      </label>
      {ajuda ? <p className="campo__ajuda">{ajuda}</p> : null}
    </div>
  );
}
